module.exports = __webpack_public_path__ + "img/8clubs.e600ce68.jpg";